define('modules/profiles/main/views/profile.submenu.view',[
    'client',
    'jquery',
    'underscore',
    'backbone',
    "marionette",
    'modules/base/views/model.view',
    "modules/base/views/submenu.view",
    "modules/profiles/subviews/views/profile.following.btn.view",
    "modules/profiles/subviews/views/profile.monitoring.view",
    "text!modules/profiles/main/templates/profile.submenu.template.html"
], function(Prospector, $,_,Backbone,
            Marionette,
            ModelView,
            SubMenuView,
            ProfileFollowingView,
            ProfileMonitoringView,
            Template
) {
    var ProfileSubMenuView = SubMenuView.extend({
        template: _.template(Template),
        events:{
            'click .editLists'      : 'editLists',
            'click .feed'           : 'feed',
            'click .export'         : 'exportDrawer',
            'click .salesForce'     : 'salesForce',
            'click .glue'           : 'glue',
            'click .boardEx'        : 'boardEx',
            'click .upgradePlan'    : 'procPurchaseCategory'
        },
        className: 'profileSubMenu',
        isFirstLoad: true,
        initialize:function(options){
            Prospector.off("openFeedResults");
            Prospector.off("forceOpenFeed");
            Prospector.on("openFeedResults", this.openFeedResults, this);
            Prospector.on("forceOpenFeed", this.forceOpenFeed, this);
            Prospector.on("glueTrigger", this.procGlueTrigger, this);
            SubMenuView.prototype.initialize.call(this, options);
            ModelView.prototype.initialize.call(this, options); //added this
        },
        //added buildModel function
        buildModel:function(){
            this.model = window.contractQuotas;
        },
        // editLists:function(e){
        //     var that = this;
        //     require(["modules/profiles/subviews/views/edit.contact.sub.view"],
        //     function(EditContactSubView){
        //         var mECSV = new EditContactSubView({parent: that.parent, model: that.parent.model});
        //         that.showView(e, "EditContactSubView", mECSV);
        //     });
        // },
        onRender:function(){
            var identity = this.parent.model.get('identityType');

            if(Prospector.SettingsApp.hasRoleMonitoring()){
                var source = this.parent.model.get('source').sourceId;
                if((source == 20 || source == 27) && identity == "organization") {
                    var mv = new ProfileMonitoringView({model: this.parent.model, check: true, parent: this.parent});
                    this.$('.feed').before(mv.render().el);
                    this.monitoringBtn = mv;
                }
            }

            if(Prospector.SettingsApp.hasFollowing()){
                var fv = new ProfileFollowingView({model: this.parent.model, check: true, parent: this.parent});
                this.$('.feed').append(fv.render().el);
                this.followingBtn = fv;
            }

            if(Prospector.SettingsApp.hasSalesForce() && this.parent.model.get('identityType') == 'person'){
                this.$('.salesForce').show();
                $(this.el).addClass('hasSalesForce');
            }
            else {
                this.$('.salesForce').hide();
            }

            if(Prospector.SettingsApp.hasBoardExEnterprise() && this.parent.model.get('boardExRefId') != ""){
                this.$('.boardEx').show();
                $(this.el).addClass('hasBoardEx');
            }
            else {
                this.$('.boardEx').hide();
            }

            if(Prospector.SettingsApp.hasTick42Glue()){
                //if(identity == "organization") {
                    this.$('.glue').show();
                    $(this.el).addClass('hasGlue');
                // }
                // else {
                //     this.$('.glue').hide();
                //  }
            }
             else {
                 this.$('.glue').hide();
             }

            //builds logic of when to show stats on top of header
            //this.buildRow('Profile loads', 'identityProfileLoads');
            SubMenuView.prototype.onRender.call(this);

            this.isFirstLoad = false;

            this.procGlueTrigger();
        },
        procGlueTrigger:function(){
            var identity = this.parent.model.get('identityType');
            // if(Prospector.SettingsApp.hasTick42Glue()){
            if (Prospector.SettingsApp.hasTick42Glue() && !this.isFirstLoad) {
                if(identity == "organization") {
                    this.$('.glue').show();
                    $(this.el).addClass('hasGlue');
                }
            }
        },

        glue: function() {
            if(Prospector.SettingsApp.isGlueNetSuiteConnected()){
                var identity = this.parent.model.get('identityType');
                if (identity == "organization") {
                    this.glueOrganizationDrawer();
                }
                else {
                    this.glueIndividualDrawer();
                }
            } else {
                this.parent.messageOut("Please log into NetSuite in another window and try again.");
            }

        },
        updateFollowing:function(){
            this.followingBtn.destroy();
            var fv = new ProfileFollowingView({model: this.parent.model, check: true, parent: this.parent});
            this.$('.feed').before(fv.render().el);
            this.followingBtn = fv;
        },
       /* exportDrawer:function(e){
            var that = this;
            require(["modules/profiles/subviews/views/export.sub.view"],
                function(ExportSubView){
                    var mESV = new ExportSubView({parent: that.parent});
                    that.showView(e, "ExportDrawer", mESV, '.export', true);
                });
        },
        feed:function(e){
            var that = this;
            require(["modules/profiles/subviews/views/feed.drawer"],
                function(FeedDrawer){
                    var mECSV = new FeedDrawer({parent: that.parent});
                    that.showView(e, "FeedDrawer", mECSV, '.feed', true);
                });
        },
        glueOrganizationDrawer:function(e){
            var that = this;
            require(["modules/profiles/subviews/views/glue.organization.view"],
                function(GlueOrganizationView){
                    var mGOV = new GlueOrganizationView({parent: that.parent});
                    that.showView(e, "Glue", mGOV, '.glue', true);
                });
        },
        boardEx:function(e) {
            var that = this;
            require(["modules/profiles/subviews/views/profile.boardex.drawer"],
                function (BoardExExportSubView) {
                    var mECSV = new BoardExExportSubView({parent: that.parent});
                    that.showView(e, "BoardEx", mECSV, '.boardEx', true);
                });
        },
        glueIndividualDrawer:function(e){
            var that = this;
            require(["modules/profiles/subviews/views/glue.individual.view"],
                function(GlueOrganizationView){
                    var mGOV = new GlueOrganizationView({parent: that.parent});
                    that.showView(e, "Glue", mGOV, '.glue', true);
                });
        },
        salesForce:function(e){
            var that = this;
            require(["modules/profiles/subviews/views/profile.salesforce.drawer"],
                function(ProfileSalesforceDrawer){
                    var mECSV = new ProfileSalesforceDrawer({parent: that.parent});
                    that.showView(e, "SalesForce", mECSV, '.salesForce', true);
                });
        },
        feedSilentOpen:function(){
            var that = this;
            require(["modules/profiles/subviews/views/feed.drawer"],
            function(FeedDrawer){
                var mECSV = new FeedDrawer({parent: that.parent});
                that.showView(undefined, "FeedDrawer", mECSV, '.feed', false);
            });
        },*/
        showView:function(e, type, view, selector, open){
            SubMenuView.prototype.showView.call(this, {
               type: type,
               event: e,
               selector: selector ,
               view: view,
               open: open
            });
        },
        openFeedResults:function(options){
            if(this.isOpen() && this.currentView == "FeedDrawer") {
                Prospector.trigger('loadFeedResults');
                if(options.view != undefined){
                    options.view.close();
                }
            } else {
                this.currentView = "";
            }
        },
        forceOpenFeed:function(){
            this.currentView = "";
            this.feed();
        }
    });
    return ProfileSubMenuView;
});
